<template>
  <div>
    <b-modal id="TeamsDonationModal" size="xl" ref="TeamsDonationModal">
      <div slot="modal-header">
        <h2>{{ $t("dashboard.campaign_team_donation", "Team Donation") }}</h2>
        <div class="modal-header__hide" @click="hide">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>

      <b-overlay :show="loading" rounded="sm">
        <b-row class="row flex-column col-12 mb-3">
          <b-col @click="donationChartCollapse = !donationChartCollapse">
            <div type="button">
              <b-icon
                :class="donationChartCollapse ? 'rotate-180' : ''"
                id="collapse-icon"
                v-b-tooltip.hover.top="
                  this.$t('dashboard.teams_tooltip_donation_chart', 'View donation graph')
                "
                icon="chevron-down"
              ></b-icon>
              {{ $t("dashboard.team_donation_chart", "View donation graph") }}
            </div>
          </b-col>

          <b-col>
            <b-collapse v-model="donationChartCollapse" class="mt-2">
              <b-card>
                <teamDonationChart v-if="teamDonationsList.length" :donation="teamDonationsList" />
              </b-card>
            </b-collapse>
          </b-col>
        </b-row>

        <b-card no-body>
          <b-tabs card>
            <b-tab
              :title="`${$t('dashboard.select_filter_processed', 'Processed')} (${
                stats.processed.total
              })`"
              active
            >
              <teamDonationTable
                :team-id="id"
                @loading="loaging = true"
                @data="onData('processed', $event)"
              />
            </b-tab>
            <b-tab
              :title="`${$t('dashboard.select_filter_authorized', 'Authorized')} (${
                stats.authorized.total
              })`"
            >
              <teamDonationTable
                :team-id="id"
                status="authorized"
                @loading="loaging = true"
                @data="onData('authorized', $event)"
              />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-overlay>
      <div slot="modal-footer">
        <button type="button" class="bttn bttn--lg bttn--blue" @click="hide" name="button">
          {{ $t("teams.close") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import teamDonationChart from "./teamDonationChart.vue";
import teamDonationTable from "./teamsDonationTable.vue";

export default {
  components: {
    teamDonationChart,
    teamDonationTable,
  },
  name: "TeamsDonationModal",
  data() {
    return {
      id: 0,
      fields: [
        "id",
        "date",
        "name",
        "display_name",
        "charged_amount",
        "effective_amount",
        "email",
        "phone",
      ],
      donationChartCollapse: false,
      loading: false,
      teamDonationsList: [],
      stats: {
        processed: {
          total: 0,
        },
        authorized: {
          total: 0,
        },
      },
    };
  },
  computed: {
    ...mapState({
      campaignId: (state) => state.dashboard.selectedCampaign,
      campaignCurrencySign: (state) => state.campaign.campaign.data.attributes.currency_sign,
    }),
  },
  methods: {
    show(id) {
      this.$refs.TeamsDonationModal.show(id);
      this.id = id;
    },
    hide() {
      this.$refs.TeamsDonationModal.hide();
      this.teamDonationsList = [];
      this.stats.processed.total = 0;
      this.stats.authorized.total = 0;
      this.loading = false;
      this.donationChartCollapse = false;
    },
    onData(status, data) {
      this.teamDonationsList.push(...data.list);
      this.stats[status].total = data.total;
    },
  },
};
</script>

<style lang="scss" scoped>
.no-data {
  min-height: 64px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
#collapse-icon {
  transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1);
}
.rotate-180 {
  transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  stroke: #107598;
  transform: rotate(180deg);
}
</style>
